import { useHMSMicrophone } from "../hms/useHMSMicrophone";
import { useLivekitMicrophone } from "../livekit/useLivekitMicrophone";
import { useProviderHook } from "./useProviderHook";

export const useProviderMicrophone = () =>
  useProviderHook({
    hms: useHMSMicrophone,
    livekit: useLivekitMicrophone,
  })();
